export default {
	RATIO_VERY_ENCOUNTER : 3,
	RATIO_ENCOUNTER : 8
}
